module.exports = __webpack_public_path__ + "media/icon/icon-facebook-0bd6f62a.svg";